import React from 'react'
import { ComponentDidMount } from './lifecycleMethods'
import { navigate } from 'widgets-for-react'

export const Redirect = (p: { to: string; butFirst?: () => void }) => (
  <ComponentDidMount
    onMount={() => {
      if (p.butFirst) p.butFirst()
      const url = new URL(p.to, window.location.href)
      if (window.location.pathname == url.pathname) navigate('/')
      else navigate(p.to)
    }}
  />
)
